import React, { useEffect, useState } from 'react';
import { Button, Modal, Result, Table, Tooltip } from 'antd'
import { LikeFilled, LikeOutlined, ReloadOutlined } from '@ant-design/icons';
import { apiBudgetVote, apiGetNearbyProjects, apiGetVotedProjects } from '../../../utils/api';
import { useScreenSize } from '../../../hooks/useScreenSize';
import { prMain } from '../../../themeConfig';
import { MyVotes } from './MyVotes';

const VotesTable = (props) => {

  const { setfilter, filter, clickSearch } = props

  const { width, height } = useScreenSize()
  const [data, setData] = useState([])
  const [filterData, setFilterData] = useState([]);

  const [tab, settab] = useState(1)
  const [rowSelected, setrowSelected] = useState(null)

  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [openModal, setOpenModal] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState({
    title: "",
    description: ""
  })
  const [refreshVotes, setRefreshVotes] = useState(false)

  const columns = [
    {
      title: 'Proyecto',
      key: 'projectName',
      render: row => (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '.5rem' }}>
          <Tooltip title={row.projectName}>
            <div style={{ inlineSize: '85%', overflowWrap: 'break-word' }}>
              {row.projectName}
            </div>
          </Tooltip>

          <Tooltip title={tab !== 4 ? "Votar" : "Votado"}>
            <Button 
              type='link' 
              icon={[1, 2, 3].some(i => i === tab) ? <LikeOutlined style={{ color: '#000' }} /> : <LikeFilled style={{ color: prMain }} />} 
              onClick={() => [1, 2, 3].some(i => i === tab) && handleOpen(row)}
            />
          </Tooltip>
        </div>
      )
    }
  ]

  const handleOpen = (row) => {
    setOpenModal(true)
    setrowSelected(row)
  }

  const handleClose = () => {
    setOpenModal(false)
    setError(false)
    setSuccess(false)
  }

  const getTypeFromTab = (tabNumber) => {
    switch(tabNumber) {
      case 1: return 0; // Mi Zona
      case 2: return 1; // Educativa (Escolar)
      case 3: return 2; // General
      default: return 0;
    }
  }

  const handleVote = () => {
    let user = JSON.parse(sessionStorage.getItem('userVotes'))
    const voteType = getTypeFromTab(tab)
    
    apiBudgetVote(rowSelected.idBudgetParticipatory, user.idUserVoteBudget, voteType).then(() => {
      setRefreshVotes(prev => !prev)
      setRefresh(!refresh)
      setSuccess(true)
      setError(false)
    }).catch((e) => {
      console.log(e)
      if (e.response.status === 412) {
        setErrorMessage({
          title: "Límite de votos alcanzado",
          description: `Has alcanzado el límite de 1 voto de proyectos ${
            tab === 1 ? 'de tu zona' : 
            tab === 2 ? 'educativos' : 
            'generales'
          }`
        })
      } else if (e.response.status === 406) {
        setErrorMessage({
          title: "Votación Desactivada",
          description: "No es posible utilizar el servicio de votación debido a que se encuentra desactivado"
        })
      } else if (e.response.status === 409) {
        setErrorMessage({
          title: "CURP no registrada",
          description: "Para poder votar necesitas tener tu CURP registrada en tu perfil de usuario"
        })
      } else {
        setErrorMessage({
          title: "Error al intentar votar",
          description: "Ha ocurrido un error al intentar registrar el voto. Por favor intente de nuevo."
        })
      }
      setSuccess(false)
      setError(true)
    })
  }

  useEffect(() => {
    if (tab === 4) return // Tab 4 es "Mis Votos"
    
    setLoading(true)
    setfilter("")
    let userVotes = JSON.parse(sessionStorage.getItem('userVotes'))

    setFilterData([])
    setData([])
    
    const voteType = getTypeFromTab(tab)
    
    apiGetNearbyProjects(userVotes.curp, voteType).then((response) => {
      setFilterData(response.data)
      setData(response.data)
    }).catch(err => {
      new Error(err)
    }).finally(() => {
      setLoading(false)
    })

  }, [refresh, tab])

  useEffect(() => {
    if (filter.length === 0) {
      setFilterData(data)
    } else {
      const search = filter.split(' ').filter(item => item !== '');
      const dataFilter = data.filter(item => {
        return (search.every(word =>
          item.projectName.toLowerCase().includes(word.toLowerCase())
        ))
      })
      setFilterData(dataFilter)
    }
  }, [clickSearch])

  useEffect(() => {
    if (filter) return
    setFilterData(data)
  }, [filter])

  useEffect(() => {
    if (tab === 4) return
  
    let userVotes = JSON.parse(sessionStorage.getItem('userVotes'))
  
    apiGetVotedProjects(userVotes.curp, 'active').then((response) => {
      const votes = {
        zone: [],
        educativa: [],
        general: []
      }
  
      response.data.forEach(item => {
        if (item.Zona) votes.zone = item.Zona
        if (item.School) votes.educativa = item.School
        if (item.General) votes.general = item.General
      })
  
      if (votes.zone.length >= 1 && votes.educativa.length >= 1 && votes.general.length >= 1) {
        settab(4)
      } else if (votes.zone.length === 0) {
        settab(1)
      } else if (votes.educativa.length === 0) {
        settab(2)
      } else if (votes.general.length === 0) {
        settab(3)
      } else {
        settab(1)
      }
    }).catch(err => {
      console.error('❌ ERROR:', err)
      new Error(err)
    }).finally(() => {
      setLoading(false)
    })
  }, [tab, refreshVotes])

  // ✅ Función para obtener el título del tab
  const getTabTitle = () => {
    switch(tab) {
      case 1: return 'Proyectos De Mi Zona';
      case 2: return 'Proyectos Educativos'; // Tab 2 = Educativa
      case 3: return 'Proyectos Generales';  // Tab 3 = General
      case 4: return 'Mis Votos';
      default: return '';
    }
  }

  // ✅ Función para obtener el límite de votos
  const getVoteLimit = () => {
    switch(tab) {
      case 1: return '1 proyecto'; // ✅ Mi Zona - CAMBIO de 2 a 1
      case 2: return '1 proyecto'; // Educativa
      case 3: return '1 proyecto'; // General
      default: return '';
    }
  }

  return (
    <>
      <div style={{ paddingTop: width > 760 ? 15 : 10 }}>
        <div style={{ display: 'flex', justifyContent: width > 760 ? 'flex-start' : 'center' }}>
          <div style={{ width: '100%', textAlign: 'center', fontSize: '1.2rem', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '.6rem', color: prMain }}>
            <div style={{ width: '1.6rem', height: '1.6rem', borderRadius: 100, border: `2px solid ${prMain}`, fontSize: '1rem', display: 'grid', placeContent: 'center' }}> 
              {tab} 
            </div>
            {getTabTitle()}
          </div>
        </div>
        
        {tab !== 4 && (
          <>
            <div style={{ opacity: .5 }}>
              Puede votar por {getVoteLimit()} de esta categoría
            </div>
            <Table
              rowKey={record => record.idBudgetParticipatory}
              loading={loading}
              columns={columns}
              dataSource={filterData}
              size="small"
              scroll={{ y: height > 620 ? '48vh' : '40vh', x: width > 760 ? '100%' : '100%' }}
              pagination={{ defaultPageSize: 10, showSizeChanger: true, pageSizeOptions: ['10', '20', '30', '40', '50'] }}
            />
            <div style={{ marginTop: '-50px' }} >
              <Button type='link' icon={<ReloadOutlined />} onClick={() => setRefresh(!refresh)}>Recargar datos</Button>
            </div>
          </>
        )}
        
        {tab === 4 && (
          <MyVotes columns={columns} filter={filter} clickSearch={clickSearch} />
        )}
      </div>

      <Modal
        centered
        visible={openModal}
        closable={false}
        footer={null}
        onCancel={() => handleClose(false)}>
        {(!success && !error && rowSelected) &&
          <Result
            status={'info'}
            title={'Votar por este proyecto'}
            subTitle={`¿Desea votar por el proyecto "${rowSelected.projectName}"?`}
            extra={[
              <Button type='link' key='cancel' onClick={() => handleClose(false)}>Cancelar</Button>,
              <Button type='primary' key='approve' onClick={() => handleVote()} >Continuar</Button>,
            ]}
          />
        }
        {(success && !error) &&
          <Result
            status={'success'}
            title={'Voto registrado'}
            subTitle={'Su voto ha sido registrado exitosamente.'}
            extra={[
              <Button type='primary' key='cancel' onClick={() => handleClose(true)}>Cerrar</Button>,
            ]}
          />
        }
        {(error && !success) &&
          <Result
            status={'error'}
            title={errorMessage.title}
            subTitle={errorMessage.description}
            extra={[
              <Button type='primary' key='cancel' onClick={() => handleClose(false)}>Cerrar</Button>,
            ]}
          />
        }
      </Modal>
    </>
  );
}
export default VotesTable;